import { MsalProvider } from '@azure/msal-react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { msalInstance } from './lib/auth';
import { AuthGate } from './components/Layout/AuthGate';
import { Shell } from './components/Layout/Shell';
import { Dashboard } from './pages/Dashboard';
import { PersonalDashboardPage } from './pages/PersonalDashboardPage';
import { Templates } from './pages/Templates';
import { AIBuilderPage } from './pages/AIBuilderPage';
import { SavedReportsPage } from './pages/SavedReportsPage';
import { SchedulesPage } from './pages/SchedulesPage';
import { AdminPage } from './pages/AdminPage';
import { TemplateRunner } from './components/Templates/TemplateRunner';

export default function App() {
  return (
    <MsalProvider instance={msalInstance}>
      <BrowserRouter>
        <AuthGate>
          <Shell>
            <Routes>
              <Route path="/"                     element={<Navigate to="/dashboard" replace />} />
              <Route path="/dashboard"            element={<Dashboard />} />
              <Route path="/dashboard/personal"   element={<PersonalDashboardPage />} />
              <Route path="/templates"            element={<Templates />} />
              <Route path="/templates/:key"       element={<TemplateRunner />} />
              <Route path="/ai"                   element={<AIBuilderPage />} />
              <Route path="/reports"              element={<SavedReportsPage />} />
              <Route path="/schedules"            element={<SchedulesPage />} />
              <Route path="/admin"                element={<AdminPage />} />
              <Route path="/auth/callback"        element={<Navigate to="/" replace />} />
            </Routes>
          </Shell>
        </AuthGate>
      </BrowserRouter>
    </MsalProvider>
  );
}
